import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"

// export const emailVerification = createAsyncThunk("/request-code/email", async (data, { rejectWithValue }) => {
//   try {
//     const response = await apiRequest.post("/request-code/email?flow=changeEmailAddress", data)
//     return response.data
//   } catch (error) {
//     const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to create custom user'
//     return rejectWithValue(errorMessage)
//   }
// })

export const ssnNumberResponse = createAsyncThunk("/customers/addSsnById", async ({ userId, ssNumber }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put(`/customUsers/${userId}`, { ssNumber })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed ssn number'
    return rejectWithValue(errorMessage)
  }
})

export const emailBankAccount = createAsyncThunk("/request-code/email", async (data, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/mails/bank-info/users/${data?.userId}`, {
      email: data?.email,
      lsaTemplateType: data?.lsaTemplateType,
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to create custom user'
    return rejectWithValue(errorMessage)
  }
})

export const smsBankAccount = createAsyncThunk("/request-code/phone", async (data, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/sms/bank-info/users/${data?.userId}`, {
      phoneNumber: data?.phoneNumber,
      lsaTemplateType: data?.lsaTemplateType,
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to send the text message'
    return rejectWithValue(errorMessage)
  }
})

export const estimatePayments = createAsyncThunk("/estimate-payments", async (data, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post("/estimate-payments", data)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed estimate payments'
    return rejectWithValue(errorMessage)
  }
})

export const sendLeadDetails = createAsyncThunk("/lead-details", async ({ userId, postData }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/lead-details/${userId}`, postData)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error?.errors?.[0]?.message
      || error.response?.data?.message
      || 'Failed to create the lead details'
    return rejectWithValue(errorMessage)
  }
})

export const getLeadDetails = createAsyncThunk("/lead-details", async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/lead-details/${userId}`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch data'
    return rejectWithValue(errorMessage)
  }
})

export const editNewLeadDetails = createAsyncThunk("/lead-details", async ({ userId, data }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put(`/lead-details/${userId}`, data)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error?.errors?.[0]?.message
      || error.response?.data?.message
      || 'Failed to save the lead details'
    // The code rides on meta (WS #2228897: the Program Plan screen asks before a split is dropped);
    // the payload stays the message every caller shows.
    return rejectWithValue(errorMessage, { code: error.response?.data?.error?.errors?.[0]?.code })
  }
})

export const addAssigneesToContact = createAsyncThunk("/customUsers", async ({ userId, data }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put(`/customUsers/${userId}/assignees`, data)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed calculator data'
    return rejectWithValue(errorMessage)
  }
})

export const sendProposalEmail = createAsyncThunk("/mails/proposal/users/:userId", async ({ leadData, userId }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/mails/proposal/users/${userId}`, { leadData })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to send proposal email'
    return rejectWithValue(errorMessage)
  }
})
